import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=2d314424&scoped=true&"
import script from "./SystemInfo.vue?vue&type=script&lang=js&"
export * from "./SystemInfo.vue?vue&type=script&lang=js&"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=2d314424&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d314424",
  null
  
)

export default component.exports